// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/icomoon.eot?tww501", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/icomoon.ttf?tww501", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/icomoon.woff?tww501", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/icomoon.svg?tww501", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-icon-30:before {
  content: "\\e91d";
}
.icon-icon-31:before {
  content: "\\e91e";
}
.icon-icon-32:before {
  content: "\\e91f";
}
.icon-icon-1:before {
  content: "\\e900";
}
.icon-icon-2:before {
  content: "\\e901";
}
.icon-icon-3:before {
  content: "\\e902";
}
.icon-icon-4:before {
  content: "\\e903";
}
.icon-icon-5:before {
  content: "\\e904";
}
.icon-icon-6:before {
  content: "\\e905";
}
.icon-icon-7:before {
  content: "\\e906";
}
.icon-icon-8:before {
  content: "\\e907";
}
.icon-icon-9:before {
  content: "\\e908";
}
.icon-icon-10:before {
  content: "\\e909";
}
.icon-icon-11:before {
  content: "\\e90a";
}
.icon-icon-12:before {
  content: "\\e90b";
}
.icon-icon-13:before {
  content: "\\e90c";
}
.icon-icon-14:before {
  content: "\\e90d";
}
.icon-icon-15:before {
  content: "\\e90e";
}
.icon-icon-16:before {
  content: "\\e90f";
}
.icon-icon-17:before {
  content: "\\e910";
}
.icon-icon-18:before {
  content: "\\e911";
}
.icon-icon-19:before {
  content: "\\e912";
}
.icon-icon-20:before {
  content: "\\e913";
}
.icon-icon-21:before {
  content: "\\e914";
}
.icon-icon-22:before {
  content: "\\e915";
}
.icon-icon-23:before {
  content: "\\e916";
}
.icon-icon-24:before {
  content: "\\e917";
}
.icon-icon-25:before {
  content: "\\e918";
}
.icon-icon-26:before {
  content: "\\e919";
}
.icon-icon-27:before {
  content: "\\e91a";
}
.icon-icon-28:before {
  content: "\\e91b";
}
.icon-icon-29:before {
  content: "\\e91c";
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/Icon/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAAqC;EACrC;;;yDAGuD;EACvD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('fonts/icomoon.eot?tww501');\n  src:  url('fonts/icomoon.eot?tww501#iefix') format('embedded-opentype'),\n    url('fonts/icomoon.ttf?tww501') format('truetype'),\n    url('fonts/icomoon.woff?tww501') format('woff'),\n    url('fonts/icomoon.svg?tww501#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-icon-30:before {\n  content: \"\\e91d\";\n}\n.icon-icon-31:before {\n  content: \"\\e91e\";\n}\n.icon-icon-32:before {\n  content: \"\\e91f\";\n}\n.icon-icon-1:before {\n  content: \"\\e900\";\n}\n.icon-icon-2:before {\n  content: \"\\e901\";\n}\n.icon-icon-3:before {\n  content: \"\\e902\";\n}\n.icon-icon-4:before {\n  content: \"\\e903\";\n}\n.icon-icon-5:before {\n  content: \"\\e904\";\n}\n.icon-icon-6:before {\n  content: \"\\e905\";\n}\n.icon-icon-7:before {\n  content: \"\\e906\";\n}\n.icon-icon-8:before {\n  content: \"\\e907\";\n}\n.icon-icon-9:before {\n  content: \"\\e908\";\n}\n.icon-icon-10:before {\n  content: \"\\e909\";\n}\n.icon-icon-11:before {\n  content: \"\\e90a\";\n}\n.icon-icon-12:before {\n  content: \"\\e90b\";\n}\n.icon-icon-13:before {\n  content: \"\\e90c\";\n}\n.icon-icon-14:before {\n  content: \"\\e90d\";\n}\n.icon-icon-15:before {\n  content: \"\\e90e\";\n}\n.icon-icon-16:before {\n  content: \"\\e90f\";\n}\n.icon-icon-17:before {\n  content: \"\\e910\";\n}\n.icon-icon-18:before {\n  content: \"\\e911\";\n}\n.icon-icon-19:before {\n  content: \"\\e912\";\n}\n.icon-icon-20:before {\n  content: \"\\e913\";\n}\n.icon-icon-21:before {\n  content: \"\\e914\";\n}\n.icon-icon-22:before {\n  content: \"\\e915\";\n}\n.icon-icon-23:before {\n  content: \"\\e916\";\n}\n.icon-icon-24:before {\n  content: \"\\e917\";\n}\n.icon-icon-25:before {\n  content: \"\\e918\";\n}\n.icon-icon-26:before {\n  content: \"\\e919\";\n}\n.icon-icon-27:before {\n  content: \"\\e91a\";\n}\n.icon-icon-28:before {\n  content: \"\\e91b\";\n}\n.icon-icon-29:before {\n  content: \"\\e91c\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
